/* eslint-disable react/prop-types */
import { WarrantyLogModel } from '../../model/types';
import { ActionCell } from './cells/action-cell';
import { IdCell } from './cells/id-cell';
import { LinksCell } from './cells/links-cell';
import { SentToWaCell } from './cells/sent-to-wa-cell';
import { StatusCell } from './cells/status-cell';
import { TextCell } from './cells/test-cell';
import { WaStatusCell } from './cells/wa-status-cell';
import { WipRegCell } from './cells/wip-reg-cell';
import { StandardHeader } from 'components/table/headers/standard-header';
import { Column } from 'react-table';

export const TableColumns: ReadonlyArray<Column<WarrantyLogModel>> = [
  {
    Header: (props) => <StandardHeader tableProps={props} title="ID" className="w-80px text-nowrap" />,
    id: 'id',
    Cell: ({ ...props }) => <IdCell data={props.data[props.row.index]} />
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="WIP N / Reg N" className="w-80px text-nowrap" />,
    id: 'wipNo',
    Cell: ({ ...props }) => (
      <WipRegCell wipNo={props.data[props.row.index].wip} regNo={props.data[props.row.index].regno ?? ''} />
    )
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="Warranty type" className="w-80px text-nowrap" />,
    id: 'warrantyType',
    Cell: ({ ...props }) => <TextCell text={props.data[props.row.index].warrantyName ?? ''} />
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="Manufacturer" className="w-80px text-nowrap" />,
    id: 'manufacturer',
    Cell: ({ ...props }) => <TextCell text={props.data[props.row.index].manufactureName ?? ''} />
  },

  {
    Header: (props) => <StandardHeader tableProps={props} title="Sent to WA" className="w-80px text-nowrap" />,
    id: 'sentWaDateTime',
    Cell: ({ ...props }) => <SentToWaCell data={props.data[props.row.index]} />
  },

  {
    Header: (props) => <StandardHeader tableProps={props} title="@WA / WA Status" className="w-80px text-nowrap" />,
    id: 'waStatus',
    Cell: ({ ...props }) => <WaStatusCell data={props.data[props.row.index]} />
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="Status" className="w-50px text-nowrap" />,
    id: 'status',
    Cell: ({ ...props }) => <StatusCell data={props.data[props.row.index]} />
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="Links" className="w-100px text-nowrap" />,
    id: 'links',
    Cell: ({ ...props }) => <LinksCell data={props.data[props.row.index]} />
  },
  {
    Header: (props) => <StandardHeader tableProps={props} title="" className="w-80px text-nowrap" />,
    id: 'actions',
    Cell: ({ ...props }) => <ActionCell data={props.data[props.row.index]} />
  }
];
